import { apiRequest, apiUpload } from "./apiClient";
import { trackEngagementDataAdded } from "./engagementService";
import { emitRestDataChanged } from "./restEventBus";

const enc = (v) => encodeURIComponent(String(v || ""));

const emitResponseChanges = (familyId, changes = []) => {
  changes.forEach((change) => {
    emitRestDataChanged({ familyId, ...change });
    if (change.resource === "familyMembers" && typeof window !== "undefined") {
      window.dispatchEvent(new CustomEvent("fp:familyPermissionsChanged", { detail: { familyId } }));
    }
  });
};

export async function getChildrenBundle(familyId) {
  if (!familyId) return { children: [], childRecords: [], healthRecords: [] };
  const data = await apiRequest(`/children/${enc(familyId)}`);
  return {
    children: Array.isArray(data.children) ? data.children : [],
    childRecords: Array.isArray(data.childRecords) ? data.childRecords : [],
    healthRecords: Array.isArray(data.healthRecords) ? data.healthRecords : [],
  };
}

export async function createChildProfile(familyId, payload) {
  const data = await apiRequest(`/children/${enc(familyId)}/children`, {
    method: "POST",
    body: JSON.stringify(payload || {}),
  });
  const child = data.child || null;
  trackEngagementDataAdded({ familyId, moduleKey: "children", itemId: child?.id || child?.firebaseId, metadata: { source: "child_profile" } });
  return child;
}

export async function updateChildProfile(familyId, childId, payload) {
  const data = await apiRequest(`/children/${enc(familyId)}/children/${enc(childId)}`, {
    method: "PATCH",
    body: JSON.stringify(payload || {}),
  });
  return data.child || null;
}

export async function uploadChildProfilePicture(familyId, childId, file, onProgress) {
  const formData = new FormData();
  formData.append("photo", file, "child-profile-photo.webp");
  const data = await apiUpload(
    `/children/${enc(familyId)}/children/${enc(childId)}/profile-picture`,
    formData,
    { onProgress }
  );
  return data.child || null;
}

export async function deleteChildProfilePicture(familyId, childId, fallbackAvatar = null) {
  const data = await apiRequest(`/children/${enc(familyId)}/children/${enc(childId)}/profile-picture`, {
    method: "DELETE",
    body: JSON.stringify({ fallbackAvatar }),
  });
  return data.child || null;
}

export async function deleteChildProfile(familyId, childId) {
  const data = await apiRequest(`/children/${enc(familyId)}/children/${enc(childId)}`, { method: "DELETE" });
  return data.child || null;
}

export async function createChildRecord(familyId, payload) {
  const data = await apiRequest(`/children/${enc(familyId)}/records`, {
    method: "POST",
    body: JSON.stringify(payload || {}),
  });
  const record = data.record || null;
  trackEngagementDataAdded({ familyId, moduleKey: "children", itemId: record?.id || record?.firebaseId, metadata: { source: "child_record" } });
  emitResponseChanges(familyId, Array.isArray(data.changes) ? data.changes : [{ resource: "childRecords", action: "added", item: record }]);
  return record;
}

export async function deleteChildRecord(familyId, recordId) {
  const data = await apiRequest(`/children/${enc(familyId)}/records/${enc(recordId)}`, { method: "DELETE" });
  emitResponseChanges(familyId, Array.isArray(data.changes) ? data.changes : [{ resource: "childRecords", action: "deleted", itemId: recordId }]);
  return data.record || null;
}
